export default function initHeader() {
    const menuItems = [...document.querySelectorAll('.tds-site-header .tds-site-nav-item, .tds-site-header-modal .tds-site-nav-item')];
    for (let item in menuItems) {
        if (menuItems[item].href && menuItems[item].href === window.location.href) {
            menuItems[item].classList.add('tds--highlighted');
        }
    }
}
